export const TEXT = {
    Dashboard: {
        en: "Dashboard",
        ar: "لوحة المعلومات"
    },
    SelectGroupToView: {
        en: "Select a database group to view its dashboard",
        ar: "اختر مجموعة قاعدة بيانات لعرض لوحة المعلومات"
    },
    NoGroupsAvailable: {
        en: "No database groups available",
        ar: "لا توجد مجموعات قاعدة بيانات متاحة"
    },
    CreateGroupToStart: {
        en: "Create a database group to get started",
        ar: "قم بإنشاء مجموعة قاعدة بيانات للبدء"
    },
    Databases: {
        en: "Databases",
        ar: "قواعد البيانات"
    },
    ViewDashboard: {
        en: "View Dashboard",
        ar: "عرض لوحة المعلومات"
    },
    BackToGroups: {
        en: "Back to Groups",
        ar: "العودة إلى المجموعات"
    }
};
export default TEXT;
